import React, { FunctionComponent } from 'react'
import { Button, Heading, Modal, Icon, Text, useModal } from '@afterpaytouch/core'
import styles from './style.module.css'
import { useTranslation } from '../../utils/convergence'
import { Trans } from '../../utils/convergence'
import { IdentityVerificationTerminalErrorModalKey } from '../../model'

export const IdentityVerificationTerminalErrorModal: FunctionComponent = () => {
  const { t } = useTranslation()
  const { visible, closeModal } = useModal(IdentityVerificationTerminalErrorModalKey)

  const components = {
    bold: <strong />,
    br: <br />,
  }

  return (
    <Modal id={IdentityVerificationTerminalErrorModalKey} show={visible}>
      <div className={styles.container}>
        <Modal.Header>
          <div className={styles.heading}>
            <div>
              <Button.Link
                type='button'
                size='Large'
                aria-label='identity-verification-terminal-error-back'
                testNameSpace='identity-verification-terminal-error-back'
                onClick={closeModal}
              >
                <Icon.ArrowLeft size='Small' />
              </Button.Link>
            </div>
            <Heading size='XL'>{t('terminalError:identityVerificationDeclinedPCL.informationModal.heading')}</Heading>
          </div>
        </Modal.Header>
        <Modal.Content>
          <div className={styles.text}>
            <Text size='S'>
              <Trans i18nKey='terminalError:identityVerificationDeclinedPCL.informationModal.message' context={'1'} components={components} />
            </Text>
          </div>
          <div className={styles.text}>
            <Text size='S'>
              <Trans i18nKey='terminalError:identityVerificationDeclinedPCL.informationModal.message' context={'2'} components={components} />
            </Text>
          </div>
          <div className={styles.text}>
            <Text size='S'>
              <Trans i18nKey='terminalError:identityVerificationDeclinedPCL.informationModal.message' context={'3'} components={components} />
            </Text>
          </div>
          <div className={styles.text}>
            <Text size='S'>
              <Trans i18nKey='terminalError:identityVerificationDeclinedPCL.informationModal.message' context={'4'} components={components} />
            </Text>
          </div>
          <div className={styles.text}>
            <Text size='S'>
              <Trans i18nKey='terminalError:identityVerificationDeclinedPCL.informationModal.message' context={'5'} components={components} />
            </Text>
          </div>
        </Modal.Content>
      </div>
    </Modal>
  )
}
